import { getApiInstance } from './api.helpers';
export const ARCHIVE_BANNER_SUMMARY_QUERY_KEY = 'archiveBannerSummary';
export const ARCHIVE_BANNER_SUMMARY_PATH = '/v2/routes/econsent/archive_banner_summary';
export const getConsentArchiveBannerStorageKey = (environmentId, siteId) => `consentArchiveBanner:${environmentId}:${siteId}`;
export const getArchiveBannerSiteId = (environment, siteId) => {
    const resolved = siteId || environment?.siteMetadata?.orgSiteId;
    return resolved == null ? '' : String(resolved).trim();
};
export const getArchiveBannerSiteIds = (environment, siteId) => {
    if (siteId) {
        return [siteId];
    }
    const assigned = [...new Set((environment?.assignedSiteIds ?? []).filter(Boolean))];
    if (assigned.length > 0) {
        return assigned;
    }
    const fallback = getArchiveBannerSiteId(environment);
    return fallback ? [fallback] : [];
};
export const canFetchArchiveBannerSummary = (environment, siteId) => Boolean(environment?.cortexURL) && getArchiveBannerSiteIds(environment, siteId).length > 0;
export const parseArchiveBannerSummary = (payload) => {
    if (!payload || typeof payload !== 'object') {
        return null;
    }
    const candidate = payload;
    const nested = candidate.data;
    const summary = typeof candidate.archivedTemplateCount === 'number'
        ? candidate
        : nested &&
            typeof nested === 'object' &&
            typeof nested.archivedTemplateCount === 'number'
            ? nested
            : null;
    if (!summary) {
        return null;
    }
    return {
        archivedTemplateCount: summary.archivedTemplateCount,
        voidedPendingCount: summary.voidedPendingCount ?? 0,
        byParticipant: Array.isArray(summary.byParticipant) ? summary.byParticipant : [],
    };
};
export const mergeArchiveBannerSummaries = (summaries) => {
    const present = summaries.filter((summary) => Boolean(summary));
    if (present.length === 0) {
        return null;
    }
    const merged = present.reduce((acc, summary) => ({
        archivedTemplateCount: acc.archivedTemplateCount + summary.archivedTemplateCount,
        voidedPendingCount: acc.voidedPendingCount + summary.voidedPendingCount,
        byParticipant: [...acc.byParticipant, ...(summary.byParticipant ?? [])],
    }), { archivedTemplateCount: 0, voidedPendingCount: 0, byParticipant: [] });
    return merged.archivedTemplateCount > 0 ? merged : null;
};
export const fetchArchiveBannerSummary = async (environment, siteId) => {
    try {
        const response = await getApiInstance(environment).get(ARCHIVE_BANNER_SUMMARY_PATH, {
            params: { site: siteId },
        });
        return parseArchiveBannerSummary(response?.data);
    }
    catch {
        return null;
    }
};
export const readArchiveBannerDismissState = (storageKey) => {
    if (!storageKey || typeof localStorage === 'undefined') {
        return null;
    }
    try {
        const raw = localStorage.getItem(storageKey);
        if (!raw) {
            return null;
        }
        const parsed = JSON.parse(raw);
        if (typeof parsed?.dismissedCount !== 'number') {
            return null;
        }
        return parsed;
    }
    catch {
        return null;
    }
};
export const writeArchiveBannerDismissState = (storageKey, state) => {
    if (typeof localStorage === 'undefined') {
        return;
    }
    try {
        localStorage.setItem(storageKey, JSON.stringify(state));
    }
    catch {
        // Private mode / quota — dismissal is best-effort.
    }
};
export const shouldShowArchiveBanner = (archivedTemplateCount, dismissed) => {
    if (!archivedTemplateCount) {
        return false;
    }
    return dismissed == null || archivedTemplateCount > dismissed.dismissedCount;
};
